import { ReactElement, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { breakpoints } from '../../theme/breakpoints'
import { useBannerPromotionStore } from '../../store/promotion/BannerPromotionStore'
import { useSearchStore } from '../../store/search/SearchStore'
import { useMediaQuery } from '@mui/material'
import { useUserStore } from '../../store/user/UserStore'
import { observer } from 'mobx-react-lite'
import { defaultTheme } from '../../theme'

export const BannerAdsSearchResults = observer((): ReactElement | null => {
  const { fetchKeywordsAds, bannerKeywords, isChannelPartnerAdsEnabled } =
    useBannerPromotionStore()
  const bannerPromoStore = useBannerPromotionStore()
  const location = useLocation()
  const pathNaname = location.pathname
  const userStore = useUserStore()
  const searchStore = useSearchStore()
  const { searchResults } = searchStore

  const parts = searchResults?.parts

  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.laptop}px)`)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (parts && parts.length) {
      const orderNumberArray: string[] = []
      const brandArray: string[] = []

      parts.forEach((part) => {
        if (part.orderNumber) {
          orderNumberArray.push(part.orderNumber.toString())
        }

        if (part.brand) {
          brandArray.push(part.brand)
        }
      })
      const orderNumber = orderNumberArray.join(',')
      const brand = brandArray.join(',')
      fetchKeywordsAds(orderNumber, brand)
    } else {
      bannerPromoStore.setBannerKeywords(null)
    }
  }, [fetchKeywordsAds, parts, bannerPromoStore])

  useEffect(() => {
    let timeout

    const interval = setInterval(
      () => {
        setVisible(false)
        timeout = setTimeout(() => setVisible(true), 5000)
      },
      15 * 60 * 1000
    )

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])
  const getZoneId = useMemo(() => {
    if (import.meta.env.VITE_MODE === 'production') {
      if (userStore?.country?.countryCode === 'US') {
        return 30
      } else if (userStore?.country?.countryCode === 'CA') {
        return 31
      }
    } else {
      return isDesktop ? 28 : 29
    }
    return undefined
  }, [isDesktop, userStore?.country?.countryCode])

  if (
    pathNaname !== '/searchResults' ||
    !isChannelPartnerAdsEnabled() ||
    !getZoneId
  ) {
    return null
  }

  if (!bannerKeywords || bannerKeywords.adbanners.length === 0) {
    return null
  }

  return (
    <Wrapper>
      {isDesktop ? (
        <div style={{ width: '927px', height: '80px' }}>
          {visible && (
            <Iframe
              id="a3a8936a"
              name="a3a8936a"
              src={`https://ads.myplace4parts.com/www/delivery/afr.php?refresh=10&zoneid=${getZoneId}&keyword=${bannerKeywords.adbanners || 'blank'}&cb=INSERT_RANDOM_NUMBER_HERE`}
              frameBorder="0"
              scrolling="no"
              width="100%"
              height="100%"
            ></Iframe>
          )}
        </div>
      ) : (
        <div style={{ width: '358px', height: '50px' }}>
          {visible && (
            <IframeMobile
              id="a05c7ff8"
              name="a05c7ff8"
              src={`https://ads.myplace4parts.com/www/delivery/afr.php?refresh=15&zoneid=${getZoneId}&keyword=${bannerKeywords?.adbanners || 'blank'}&cb=INSERT_RANDOM_NUMBER_HERE`}
              frameBorder="0"
              scrolling="no"
              width="100%"
              height="100%"
            ></IframeMobile>
          )}
        </div>
      )}
    </Wrapper>
  )
})

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${defaultTheme.colors.siteBackground};
`
const Iframe = styled.iframe`
  border: 0;
  margin-bottom: 12px;
`

const IframeMobile = styled.iframe`
  border: 0;
  margin-bottom: 20px;
`
